/* eslint-disable @typescript-eslint/no-redeclare */
export type EmailTemplateFilterType =
  (typeof EmailTemplateFilterType)[keyof typeof EmailTemplateFilterType];
export const EmailTemplateFilterType = {
  DATA_EXTRACTOR_DROPDOWN: 'DATA_EXTRACTOR_DROPDOWN',
  CALENDAR: 'CALENDAR',
} as const;
